export const graphFilterTabs = {
  allNotes: "allNotes",
  favourites: "favourites",
};
